import { useContext } from 'react';
import styles from './TransportationSearch.module.scss';
import TransportImage from '../../assets/images/Transport.png';
import { AppContext } from '../../context/AppContext';
import { useHistory } from 'react-router-dom';
import { RouteWithState } from '../../lib/util';
import { CarIcon } from '../icons/Icons';

const TransportationSearch = () => {
  const appContext = useContext(AppContext);
  const { planCode, chosenSpecialty, location, name, directoryListType, isDisabled, distance } = appContext;
  const history = useHistory();
  //comment for push
  return (
    <>
      <div className={styles.transportationContainer}>
        {/* <div>
          <CarIcon width={'64px'} height={'64px'} isActive={true} />
        </div> */}
        <div>
          <p>
            If you are a <b>Nursing Home Plan (PPO I-SNP) member</b> or a <b>Dual Care (PPO D-SNP) member</b>, you have a <b> supplemental transportation benefit </b> for one-way trips to plan-approved health-related locations.
          </p>
          <p>
          <b>To access your benefit, contact NationsBenefits<sup>&#174;</sup>:</b>
          </p>
          <ul>
            <li>
            <b>Call 844-617-3350 (TTY:711)</b> to speak with a Member Experience Advisor who will schedule your transportation through a local provider.
            </li>
          </ul>

          <p>
            See your plan's <a href='https://simpra.com/for-members/plan-documents' target='_blank' rel='noreferrer'>
                Evidence of Coverage
                </a> for full benefit details.
          </p>
          <p>
            Download the <a href='https://simpra.com/wp-content/uploads/2026/04/SIMPAD-TRNP-FLY-FAQ-2026-EN-R3_FINAL.pdf' target='_blank' rel='noreferrer'>
                NationsBenefits<sup>&#174;</sup> FAQs
                </a> for more information.
          </p>

                    <p>
                      &copy;2026 NationsBenefits, LLC. All rights reserved. NationsBenefits is a registered trademark of NationsBenefits, LLC. Other marks are the property of their respective owners.
                    </p>
          
        </div>
        
      </div>
    </>
  );
};

export default TransportationSearch;
